import { ObjectMapper } from "json-object-mapper";
import { IModel } from "./IModel";
import { Model, OptionModel } from "./model";
import { FileModel } from "./file.model";

export class OrganizationModel
  extends Model
  implements IModel<OrganizationModel>
{
  name: string = "";
  cnpj: string = "";
  companyGroupId: string | undefined = undefined;
  imageURL: string = "";
  image: FileModel = new FileModel();

  toOption(): OptionModel {
    return {
      label: `${this.name} - ${this.cnpj}`,
      value: this.id,
    } as OptionModel;
  }

  static create(input: any): OrganizationModel {
    return ObjectMapper.deserialize<OrganizationModel>(
      OrganizationModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
